<mat-form-field class="input" [appearance]="appearance" color="primary" (click)="touched = true">
  <mat-label class="mb-xs" *ngIf="label" [ngClass]="{ asterix: required }">{{ label }}</mat-label>
  <mat-select [(ngModel)]="value" (ngModelChange)="ngModelChange.emit($event); onChange(value)"
    (change)="onChange(value)" (click)="handleClick($event); onTouched()" [errorStateMatcher]="matcher"
    [placeholder]="placeholder || valueFirst" [appDataTestid]="ngControl.name" [disabled]="isDisabled">
    <mat-select-trigger>
      <ng-content *ngTemplateOutlet="templateRef; context: { option: value }"></ng-content>
      <span *ngIf="!templateRef">{{ _optionLabel(value) }}</span>
    </mat-select-trigger>
    <mat-option *ngFor="let option of options" [value]="option">
      <ng-content *ngTemplateOutlet="templateRef; context: { option }"></ng-content>
      <span *ngIf="!templateRef">{{ _optionLabel(option) }}</span>
    </mat-option>
  </mat-select>
  <mat-error>
    <app-errors-label [label]="label" *ngIf="touched && ngControl.errors"
      [errors]="ngControl.errors"></app-errors-label>
  </mat-error>
</mat-form-field>